import { useMemo } from 'react';
import { AccessibilityInfo, Platform } from 'react-native';

export type VoiceHapticEvent = 'mic-on' | 'mic-off' | 'interrupt' | 'error';

let reducedMotion = false;
try {
  AccessibilityInfo.isReduceMotionEnabled().then((v) => {
    reducedMotion = v;
  });
} catch {
  // AccessibilityInfo unavailable
}

export function triggerVoiceHaptic(event: VoiceHapticEvent): void {
  if (Platform.OS === 'web') return;

  try {
    const Haptics = require('expo-haptics');

    switch (event) {
      case 'mic-on':
        void Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
        break;
      case 'mic-off':
        void Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
        break;
      case 'interrupt':
        void Haptics.impactAsync(
          reducedMotion
            ? Haptics.ImpactFeedbackStyle.Light
            : Haptics.ImpactFeedbackStyle.Medium,
        );
        break;
      case 'error':
        if (!reducedMotion) {
          void Haptics.notificationAsync(Haptics.NotificationFeedbackType.Warning);
        }
        break;
    }
  } catch {
    // expo-haptics unavailable
  }
}

export function useVoiceHaptics(): { trigger: (event: VoiceHapticEvent) => void } {
  return useMemo(() => ({ trigger: triggerVoiceHaptic }), []);
}
